import type { PropsWithChildren } from 'react';

import { Button } from '@/shadcn/button';
import { cn } from '@/shadcn/lib/utils';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/shadcn/tooltip';

type GenericButtonProps = PropsWithChildren<{
  tooltipContent: string;
  onClick: () => void;
  disabled?: boolean;
  isActive?: boolean;
}>;

export const ToolbarButton = ({
  disabled = false,
  children,
  onClick,
  tooltipContent,
  isActive = false
}: GenericButtonProps) => (
  <Tooltip>
    <TooltipTrigger asChild disabled={disabled}>
      <Button
        className={cn(isActive && 'bg-accent')}
        disabled={disabled}
        onMouseDown={event => {
          event.preventDefault();
          onClick();
        }}
        size="smallIcon"
        type="button"
        variant="outline"
      >
        {children}
      </Button>
    </TooltipTrigger>
    <TooltipContent>{tooltipContent}</TooltipContent>
  </Tooltip>
);

ToolbarButton.displayName = 'ToolbarButton';
